import { createRouter, createMemoryHistory } from 'vue-router';
import Page from '../views/Page.vue';
import FloatingConversation from "@/views/FloatingConversation.vue";
import { Views } from "@/types/ConfigTypes";
const routes = [
    {
        name: 'FloatingConversation',
        components: {
            floating: FloatingConversation,
        },
        path: '/conversations/:id?'
    },
    {
        name: Views.PAGE,
        components: {
            main: Page
        },
        path: '/page/:id'
    },
    {
        name: Views.CONVERSATION,
        components: {
            main: () => import('@/views/Conversation.vue')
        },
        path: '/conversations/:id?'
    },
    {
        name: Views.ARCHIVED_CONVERSATIONS,
        components: {
            main: () => import('@/views/ArchivedConversations.vue')
        },
        path: '/conversations/archived'
    },
    {
        name: Views.ARTICLE,
        components: {
            main: () => import('@/views/Article.vue'),
        },
        path: '/articles/:id?'
    },
    {
        name: Views.HELPCENTER,
        components: {
            main: () => import('@/views/HelpCenter.vue'),
        },
        path: '/helpcenter'
    },
    {
        name: Views.MAILFORM,
        components: {
            main: () => import('@/views/MailForm.vue'),
        },
        path: '/mailform'
    },
    {
        name: Views.WHATSAPP,
        components: {
            main: () => import('@/views/Whatsapp.vue'),
        },
        path: '/whatsapp/:number?'
    },
    {
        name: Views.GDPR,
        components: {
            main: () => import('@/views/Gdpr.vue'),
        },
        path: '/gdpr'
    },
    {
        path: "/:catchAll(.*)",
        components: {
            main: () => import('@/views/Empty.vue')
        }
    }
];
const router = createRouter({
    history: createMemoryHistory(),
    routes
});
export default router;
